import { render, staticRenderFns } from "./DeleteStorehouse.vue?vue&type=template&id=90fead48"
import script from "./DeleteStorehouse.vue?vue&type=script&lang=js"
export * from "./DeleteStorehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports